/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Derived status of a requisition, projected from the state of its related order(s).
 */
export enum EnumRequisitionStatus {
    /**
     * No order exists for this requisition yet.
     */
    Open = 0,
    /**
     * An order exists and is under review.
     */
    UnderReview = 1,
    /**
     * The order was rejected during review.
     */
    Rejected = 2,
    /**
     * The order was accepted and is being worked on.
     */
    InProgress = 3,
    /**
     * The order has been invoiced and that invoice has been approved. Final: a requisition never leaves
     * this state, not even when the invoice is later cancelled.
     */
    Completed = 4,
}
